module.exports = __webpack_public_path__ + "assets/img/travel-day26.a5fa0d69.png";